import {PartValueApiDto} from "./_RestModels";

export default class PartValue {
	constructor(public readonly partId: string, public readonly quantity: number, public readonly value: number) {
	}

	public static fromJson(json: PartValueApiDto): PartValue {
		return new PartValue(json.partId, json.quantity, json.value);
	}
}